export const FAVORITES_EVENTS_LABELS = {
    related: 'related',
    cart: 'cart',
    addToCartFeedback: 'add to cart feedback',
    listing: 'listing'
};
